import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { msalInstance } from './auth_sso.config';
import { Router } from '@angular/router';
import {jwtDecode} from 'jwt-decode';
import { loginConfig } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ErrorNotficationComponent } from '../../error-notfication/error-notfication.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SsoService {
  private clientId = `${loginConfig.Client_ID}`;
  private tenantId =  `${loginConfig.Tenant_ID}`;
  private redirectUri = `${loginConfig.sso_redirectUrl}/sso-auth/callback`;
  private tokenEndpoint = `https://login.microsoftonline.com/${this.tenantId}/oauth2/v2.0/token`;
  private codeVerifier: string = "";
  


  constructor(
    private http: HttpClient, 
    private router: Router, 
    private dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) {}

  url=loginConfig.apiURL_SSO;
  //url='https://ly3qqerigmcquddhphzvu32nna0mvhmi.lambda-url.ap-south-1.on.aws/api/v1/sso-auth/token_authenticate'
  async generateCodeVerifierAndChallenge() {
    // Generate a random string as the code_verifier
    this.codeVerifier = this.generateRandomString(64);

    // Generate code_challenge from code_verifier
    const codeChallenge = await this.sha256(this.codeVerifier);

    sessionStorage.setItem('code_verifier', this.codeVerifier); // Store in session
    return codeChallenge;
  }

  async login() {
    await msalInstance.initialize();

    const codeChallenge = await this.generateCodeVerifierAndChallenge();

    const authUrl = `https://login.microsoftonline.com/${this.tenantId}/oauth2/v2.0/authorize?` +
      `client_id=${this.clientId}&response_type=code&redirect_uri=${encodeURIComponent(this.redirectUri)}` +
      `&scope=openid profile email&response_mode=query` +
      `&code_challenge=${codeChallenge}&code_challenge_method=S256`;

    window.location.href = authUrl; // Redirect user to Azure for authentication
  }

  async exchangeCodeForToken(authCode: string) {
    const codeVerifier = sessionStorage.getItem('code_verifier'); // Retrieve stored verifier

    if (!codeVerifier) {
      console.error("Code Verifier is missing.");
      this.openSnackbar('Error Occured', 'An error occurred', 'error-snackbar');
      return;
    }

    const body = new URLSearchParams();
    body.set('client_id', this.clientId);
    body.set('grant_type', 'authorization_code');
    body.set('code', authCode);
    body.set('redirect_uri', this.redirectUri);
    body.set('scope', 'openid profile email');
    // body.set('client_secret', loginConfig.client_secret);
    body.set('code_verifier', codeVerifier); // Use code_verifier to complete PKCE flow

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    try {
      const response: any= await this.http.post(this.tokenEndpoint, body.toString(), { headers }).toPromise();

      // ------------ part 2 -------------
      if (!response || !response.access_token) {
        console.error("No access token received.");
         this.router.navigate(['/login']); //to-do
        return;
      }

      if (response.access_token && response.id_token) {

        // const decodedToken: any = jwtDecode(response.access_token);
        const decodedToken: any = jwtDecode(response.id_token);
  
        if(!decodedToken){
           this.router.navigate(['/login']); //to-do same like 71
        }
        
       const userInfo = {
        email: decodedToken.email,
        given_name: decodedToken.given_name,
        family_name: decodedToken.family_name,
        name:decodedToken.name
        };
        
        const data= this.http.post(this.url, userInfo);

        data.subscribe((res : any) => {
          localStorage.setItem('accessToken', res?.access_token);
          localStorage.setItem("refresh_token", res?.refresh_token);
          localStorage.setItem('user', res?.user?.role_name);
          localStorage.setItem('user_id', res?.user?.user_id)
          localStorage.setItem('user_name', res?.user?.username)
          this.router.navigate(['/home']);
        }, (error : any) => {
          if (error?.status === 401) {
            
            this.openSnackbar(error?.error?.detail, 'An error occurred', 'error-snackbar');
          } else if (error?.status === 403) {
            this.router.navigate(['/login']);
            // this.openSnackbar(error?.error?.detail, 'An error occurred', 'error-snackbar');
            const extractedEmail = this.extractEmail(error?.error?.detail);
            const parts = error?.error?.detail.split(extractedEmail);
            const beforeEmail = parts[0];
            const afterEmail = parts[1] || '';
            const formattedMessage = `${beforeEmail}<strong>${extractedEmail}</strong>${afterEmail}`;
            const sanitizedMessage: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(formattedMessage);
            this.openSnackbar(sanitizedMessage, 'An error occurred', 'show-full-message');
          } else {
            //this.openSnackbar('Something went wrong!, please try after some time...', 'An error occurred', 'error-snackbar');
          }
          //this.isLoading = false;
        })
    }     
      //this.router.navigate(['/home']); // Redirect to dashboard after login
    } catch (error) {
      console.error("Token exchange failed", error);
    }
  }

  extractEmail(input: string): string {
    const emailPattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}\b/;
    const match = input.match(emailPattern);
    return match ? match[0] : '';
  }

  async handleRedirectCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const authCode = urlParams.get('code');

    if (authCode) {
      await this.exchangeCodeForToken(authCode);
    }
  }

  // Utility functions for PKCE
  private generateRandomString(length: number): string {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return result;
  }

  private async sha256(str: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hash = await crypto.subtle.digest('SHA-256', data);
    return btoa(String.fromCharCode(...new Uint8Array(hash)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }

  openSnackbar(message: any, title: string, cssClass: string) {
         const dialogRef = this.dialog.open(ErrorNotficationComponent, {
            data: {
              message: message,
              title: title,
              action_type: 'add',
              cssClass: cssClass
            }
          });
      }


}
